module.exports = __webpack_public_path__ + "64fc4b4dd94025bf9ebc9f919d8b0870.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pos/cashier/cashPay_active.png
// module id = 573
// module chunks = 0